export default __webpack_public_path__ + "static/media/background.a73b2986.png";